import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderTitleProps } from '../../../../types/headerTitleProps'
import { PlanName } from '../PlanName'

export const FamilyPlusTitle = (props: HeaderTitleProps) => {
  const { isFamilyPlusSelected } = usePlansContext()

  return <PlanName isSelected={isFamilyPlusSelected} {...props} />
}
